import { GroupContext } from '../context.js';
import { CreateGroupEvent } from './create-group.event.js';

export async function createGroup(evt: CreateGroupEvent, ctx: GroupContext) {
  if (evt.name.length === 0 || !ctx.metadata.auth) {
    return;
  }
  await ctx.state('group').insert({
    id: evt.groupId,
    name: evt.name,
    createdAt: new Date(),
  });

  await ctx.state('groupMembers').insert({
    id: ctx.metadata.id,
    //name: ctx.metadata.auth.name,
    name: undefined,
    auth: ctx.metadata.auth,
    state: 'accepted',
    email: undefined,
    //email: ctx.metadata.auth.email,
    createdAt: ctx.metadata.createdAt,
  });
  await ctx.emit('grant-access', {
    auth: ctx.metadata.auth,
    eventGrants: [
      { event: 'invite-user', filters: [], access: 'read' },
      { event: 'invite-user', filters: [], access: 'write' },
    ],
  });
}
